var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Evaluate"},[_c('el-image',{attrs:{"src":_vm.src}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"placeholder"},slot:"placeholder"},[_vm._v(" 加载中"),_c('span',{staticClass:"dot"},[_vm._v("...")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }